/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Permissions, PermissionsInterface } from "../Permissions";

const _abi = [
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
  {
    inputs: [],
    name: "DelegateCallNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionSignatureTooShort",
    type: "error",
  },
  {
    inputs: [],
    name: "NoMembership",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughCompValuesForOneOf",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterGreaterThanAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterLessThanAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterNotOneOfAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ScopeMaxParametersExceeded",
    type: "error",
  },
  {
    inputs: [],
    name: "SendNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "TargetAddressNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "UnacceptableMultiSendOffset",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableDynamic32CompValueSize",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableOneOfComparison",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableRelativeComparison",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableStaticCompValueSize",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "AllowTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "RevokeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeAllowFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "isParamScoped",
        type: "bool[]",
      },
      {
        indexed: false,
        internalType: "enum ParameterType[]",
        name: "paramType",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "enum Comparison[]",
        name: "paramComp",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "compValue",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeFunctionExecutionOptions",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum Comparison",
        name: "paramComp",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "compValue",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeParameter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "compValues",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeParameterAsOneOf",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeRevokeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "ScopeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "UnscopeParameter",
    type: "event",
  },
];

const _bytecode =
  "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";

type PermissionsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PermissionsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Permissions__factory extends ContractFactory {
  constructor(...args: PermissionsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Permissions";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Permissions> {
    return super.deploy(overrides || {}) as Promise<Permissions>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Permissions {
    return super.attach(address) as Permissions;
  }
  connect(signer: Signer): Permissions__factory {
    return super.connect(signer) as Permissions__factory;
  }
  static readonly contractName: "Permissions";
  public readonly contractName: "Permissions";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PermissionsInterface {
    return new utils.Interface(_abi) as PermissionsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Permissions {
    return new Contract(address, _abi, signerOrProvider) as Permissions;
  }
}
